/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Permissions, PermissionsInterface } from "../Permissions";

const _abi = [
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
  {
    inputs: [],
    name: "DelegateCallNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "FunctionSignatureTooShort",
    type: "error",
  },
  {
    inputs: [],
    name: "NoMembership",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughCompValuesForOneOf",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterGreaterThanAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterLessThanAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ParameterNotOneOfAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ScopeMaxParametersExceeded",
    type: "error",
  },
  {
    inputs: [],
    name: "SendNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "TargetAddressNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "UnacceptableMultiSendOffset",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableDynamic32CompValueSize",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableOneOfComparison",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableRelativeComparison",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsuitableStaticCompValueSize",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "AllowTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "RevokeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeAllowFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "isParamScoped",
        type: "bool[]",
      },
      {
        indexed: false,
        internalType: "enum ParameterType[]",
        name: "paramType",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "enum Comparison[]",
        name: "paramComp",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "compValue",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeFunctionExecutionOptions",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum Comparison",
        name: "paramComp",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "compValue",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeParameter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "compValues",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeParameterAsOneOf",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "ScopeRevokeFunction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "ScopeTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "resultingScopeConfig",
        type: "uint256",
      },
    ],
    name: "UnscopeParameter",
    type: "event",
  },
];

const _bytecode =
  "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";

type PermissionsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PermissionsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Permissions__factory extends ContractFactory {
  constructor(...args: PermissionsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Permissions";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Permissions> {
    return super.deploy(overrides || {}) as Promise<Permissions>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Permissions {
    return super.attach(address) as Permissions;
  }
  connect(signer: Signer): Permissions__factory {
    return super.connect(signer) as Permissions__factory;
  }
  static readonly contractName: "Permissions";
  public readonly contractName: "Permissions";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PermissionsInterface {
    return new utils.Interface(_abi) as PermissionsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Permissions {
    return new Contract(address, _abi, signerOrProvider) as Permissions;
  }
}
